import { SHOW_PROMO_BANNER } from "@/config/promoBanner";

export const PromoBanner = () => {
  if (!SHOW_PROMO_BANNER) return null;

  return (
    <div className="fixed top-0 left-0 right-0 w-full text-center py-2 px-4 z-[60]" style={{ background: 'linear-gradient(90deg, #f7bbac 0%, #f9bb72 100%)' }}>
      <p className="text-sm font-bold" style={{ color: '#7a3c12' }}>
        SOUVENIRS10 : -10% + livraison gratuite*
      </p>
    </div>
  );
};